import { combineReducers } from 'redux';

import documentForm from './documentFormReducer';
import locale from './localeReducer';

export default combineReducers({
  documentForm,
  locale
});
